import React from 'react';
import { FormControl, InputAdornment, Input } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import styles from './SkillPaths.module.scss';

const InputBar = ({
  value,
  handleChange = () => null,
  placeholder = 'Search for a specific user',
}) => {
  return (
    <div className={styles.inputContainer}>
      <FormControl fullWidth>
        <Input
          value={value}
          onChange={handleChange}
          startAdornment={
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          }
          disableUnderline
          placeholder={placeholder}
        />
      </FormControl>
    </div>
  );
};
export default InputBar;
